export default __webpack_public_path__ + "static/media/Speedy 1.e8583432.png";